export const Common = {
  pls_wait_icon: "pls_wait_div",
};

export default Common;
